/* eslint-disable class-methods-use-this */
/* eslint-disable no-useless-constructor */
import { item } from '../..';
import * as marietta from '../../..';
import { Dialog } from '../../../core/view';
import { ThreeView } from '../../../view3d/webcad';
import { Mode3DTool } from '../../../view3d/webcad/util/Mode3DTool';
import { optChangeWizardMode } from '../../../view3d/webcad/util/Option3DInterface';
import { PinDialogUtil } from '../../../view3d/webcad/util/PinDialogUtil';
import { LinkType, RemarksType } from '../../collection/ItemInfoCollection';
import {
  PINPICTURE_MAXHEIGHT,
  PINPICTURE_MAXWIDTH,
} from '../../Constants';
import { MonicaObject, PinPicture } from '../../item';
import { auxiliaryConstructions, auxiliaryMiddleCategory, auxiliarySubCategory } from '../../manager/MasterManager';
import { ValidateOptions } from '../../util/InputValidationUtil';
import { AuxiliaryData, AuxiliaryDataInterface } from '../../util/LiDAR/AuxiliaryInterface';
import { WizardTool } from './WizardLiDAR';

/** after画像の情報 */
interface AfterImage {
  id?: string;
  url: string;
  name: string;
  binary: string;
}

const MasterType = {
  Default: 0,
  Company: 1,
};

interface ListSelection{
  middle:string;
  subCategory:string;
  construction:string;
}

interface nameSearchResult{
  auxiliaryConstruction:auxiliaryConstructions,
  auxiliaryConstructionList:auxiliaryConstructions[],
  subCategory:auxiliarySubCategory,
  subCategoryList:auxiliarySubCategory[],
  middleCategory:auxiliaryMiddleCategory,
  middleCategoryList:auxiliaryMiddleCategory[]
}

export default class PinPictureInfoDialog extends Dialog {
  public parentObj: PinPicture = null;

  private linkWrap: HTMLElement; // 画像部分

  private infoWrap: HTMLElement; // 工事情報部分

  private textWrap: HTMLElement; // テキスト部分

  private textElement: HTMLElement; // テキストビュー

  textGroupViewHtml: HTMLElement;

  public tarView: HTMLElement;

  public viewObj: HTMLElement;

  private middleCategoryList: auxiliaryMiddleCategory[] = [];

  private subCategoryList: auxiliarySubCategory[] = [];

  private constructionList: auxiliaryConstructions[] = [];

  private selectedConstruction: auxiliaryConstructions;

  private selectedMaster: number = MasterType.Default;

  private afterBtnBaseId: string; // after画像撮影の起動ボタンbaseID

  public view_mode: boolean = true;

  private afterImage: AfterImage[] = [];

  private listSelection:{default:ListSelection, company:ListSelection} = { default: null, company: null };

  private previousDisabledState: Record<string, boolean> = {};
  // 画像の総数
  private totalCount: number = 1;
  // 現在表示している画像のindex
  private currentNumber: number = 1;
  private addCurrentNumber(num: number) {
    const prevId = this.parentObj.itemInfo.link[this.currentNumber - 1]?.id;
    this.currentNumber += num;
    if(this.totalCount < this.currentNumber) this.currentNumber = 1;
    if(this.currentNumber < 1) this.currentNumber = this.totalCount;
    const id = this.parentObj.itemInfo.link[this.currentNumber - 1]?.id;
    if(!id) return;
    this.updateCurrentIndex(this.currentNumber);
    this.updateAfterView(id)
    this.updateBeforeView(id)
    this.updateRemarkView(id, prevId)
  }

  /**
   * コンストラクタ
   */
  constructor(draggable) {
    super(draggable);
  }

  /**
   *  内容の追加
   */
  buildContent() {
    // ダイアログのコンテンツ生成
    const id: string = 'pinPictureInfoDialog';
    // タイトル
    const title: string = '紐付け付帯工事詳細';
    // 総数
    this.totalCount = [...this.parentObj.itemInfo.link].length;
    this.afterImage = Array.from({ length: this.totalCount }, (_, i) => {
      const { itemInfo } = this.parentObj;
      const name = itemInfo.after_link[i]?.name ?? "";
      const url = itemInfo.after_link[i]?.url ?? "";
      const id = itemInfo.after_link[i]?.id ?? "";
      const binary = itemInfo.after_link[i]?.binary;
      return {name, url, id, binary};
    });
    this.createContents(this.parentObj.itemInfo);
    const contents = this.textGroupViewHtml.outerHTML;

    // シェアモードでは閲覧のみとするため、ボタンを出さずヘッダーの閉じるボタンのみとする
    const isShareMode: boolean = marietta.webcad.WebCADGlobal.shareModeManager.isShareMode;

    let footer: string = '';
    if (isShareMode) {
      footer = '';
    } else if (this.view_mode) {
      footer += '<button id="btnPinDialogCancel"><span class="jp">閉じる</span><span class="en">Cancel</span></button>';
    } else {
      footer += '<button id="btnComplete"><span class="jp">ＯＫ</span><span class="en">OK</span></button>';
      footer += '<button id="btnPinDialogCancel"><span class="jp">キャンセル</span><span class="en">Cancel</span></button>';
    }

    this.createDialog(id, title, contents, footer);

    this.createEventListner();
    if (!isShareMode) {
      (<HTMLButtonElement>document.getElementById('btnPinDialogCancel')).onclick = (e: Event) => {
        this.btnCancelHandler();
      };
    }
    if (!this.view_mode && !isShareMode) {
      (<HTMLButtonElement>document.getElementById('btnComplete')).onclick = (e: Event) => {
        this.btnCompleteHandler();
      };
    }

    // シェアモードでは表示している項目も変更させない
    if (isShareMode) {
      document.querySelectorAll(`#${id} input, #${id} select, #${id} textarea`).forEach((element) => {
        (<HTMLInputElement>element).disabled = true;
      });
    }

    // 編集モード
    if (this.view_mode && document.getElementById('masterDefault')?.parentElement) {
      document.getElementById('masterDefault').parentElement.style.pointerEvents = 'none';
    }
    // シェアモードは編集モードに切り替えない
    // 中項目・細項目などの選択肢は付帯工事マスタから作るが、共有ルートにマスタ取得APIがないため
    // 選択肢が空になる。値そのままを表示する viewMode のままにする
    if (!this.view_mode && !isShareMode) {
      this.btnEditEvent();
    }

    //引き当てアイテムがなければ、アラートを表示する（シェアモードでは紐づけを行わせない）
    if( !this.parentObj.itemInfo?.auxiliaryData && !isShareMode ){
      marietta.webcad.WebCADGlobal.showAlert( "紐づけアイテムがありません。紐づけを行ってください。" , "", () =>{
        const param = {
          isEditMode: true,
          isWizard: (marietta.webcad.WebCADGlobal.currentDialog instanceof marietta.webcad.view.dialog.WizardPinIntersect),
          itemName: PinDialogUtil.getItemName(this.parentObj.itemInfo, this.parentObj.itemInfo.intersectItem),
          roomName: PinDialogUtil.getItemRoomName(this.parentObj.itemInfo, this.parentObj.itemInfo.intersectItem, this.parentObj.itemInfo),
        };
        const dialog = marietta.webcad.WebCADGlobal.showDialog(marietta.webcad.view.dialog.PinItemChangeDialog, true, true, false, false, param);

        if (marietta.webcad.WebCADGlobal.dimensionMenu.mode === '3D') {
          dialog.callBack = this.changeItemCallBack3D;
        } else {
          dialog.callBack = this.changeItemCallBack2D;
        }
      });
    }
  }

  /**
   * DialogBody Contentsの作成
   * @param itemInfo
   */
  protected createContents(itemInfo: marietta.webcad.collection.ItemInfoCollection): void {
    console.log(`itemInfo:${JSON.stringify(itemInfo, null, 2)}`); // 2はインデントのスペース数

    // ピンクリック時に表示される枠の幅・高さの取得
    const width = this.getWidth();
    const height = this.getHeight();

    // テキストアイテムの複数行処理
    // 複数のテキスト用に個別のテキスト svg を作成する
    const textArea = document.createElement('div');

    const textAreaElemContainer: HTMLElement = document.createElement('div');
    textAreaElemContainer.setAttribute('class', 'pinPictureInput2D');
    textAreaElemContainer.setAttribute('xmlns', 'http://www.w3.org/1999/xhtml');
    textArea.appendChild(textAreaElemContainer);
    textAreaElemContainer.inert = false;

    // 吹き出しの大元部分
    const innerElement: HTMLElement = document.createElement('div');
    innerElement.setAttribute('id', `inner_${itemInfo.guid}`);
    innerElement.setAttribute('class', 'inner');
    textAreaElemContainer.appendChild(innerElement);

    // URLがあったら、画像部分の作成を行う
    if (itemInfo.link && itemInfo.link.length > 0) {
      this.linkWrap = this.createLinkElement(width);
      innerElement.appendChild(this.linkWrap);
    }
    this.infoWrap = this.createInfoElement();
    innerElement.appendChild(this.infoWrap);

    // テキスト入力
    const textString = itemInfo.text; // テキストサイズを取得
    const textArray = textString.split('\n'); // テキスト項目に改行があれば分割
    this.textElement = this.createTextElement(textArray);
    innerElement.appendChild(this.textElement);

    this.textGroupViewHtml = document.createElement('div');
    this.setTextAreaStyle(this.textGroupViewHtml, width, height);
    this.textGroupViewHtml.setAttribute('class', 'pinPictureWrapInfoContent');
    this.textGroupViewHtml.setAttribute('id', `${itemInfo.id}_${itemInfo.guid}_pinTextInfoGroup`);
    this.textGroupViewHtml.appendChild(textArea);
  }

  /**
   * 複数のテキスト用に個別のテキスト svg を作成する
   */
  protected setTextAreaStyle(textArea: HTMLElement, width: number, height: number): Node {
    // textArea.setAttribute('transform', `translate(${this.rectX()}, ${this.rectY()})`);
    textArea.style.width = `${width}px`;
    textArea.style.height = `${height}px`;

    return textArea;
  }

  /**
   * 幅取得
   */
  public getWidth(): number {
    return PINPICTURE_MAXWIDTH;
  }

  /**
   * 高さ取得
   */
  public getHeight(): number {
    return this.view_mode ? PINPICTURE_MAXHEIGHT - 40 : PINPICTURE_MAXHEIGHT + 35;
  }

  /**
   * テキスト入力スタイル設定
   */
  protected createTextElement(textArray: string[]) {
    const parentElement: HTMLElement = document.createElement('div');
    parentElement.style.display = 'none';
    parentElement.setAttribute('class', 'textWrapView');

    const btn: HTMLElement = document.createElement('a');
    btn.innerHTML = '×';
    btn.setAttribute('class', 'btn-circle');
    btn.setAttribute('href', '#');
    btn.addEventListener('pointerdown', (e) => {
      e.stopPropagation();
      this.setDisplay();
    });

    let textElement: HTMLElement = document.createElement('div');
    textElement.setAttribute('class', 'textArea');

    textElement = this.setTextStyle(textElement);
    const text = textArray.join('<br>');
    textElement.innerHTML = text;

    parentElement.appendChild(btn);
    parentElement.appendChild(textElement);

    return parentElement;
  }

  /**
   * ディスプレイの切り替え
   */
  private setDisplay() {
    // displayをnoneにして、
    this.linkWrap.style.display = this.linkWrap.style.display == 'none' ? 'block' : 'none';
    this.textWrap.style.display = this.textWrap.style.display == 'none' ? 'block' : 'none';
    // innerの中のテキストをdisplay block
    this.textElement.style.display = this.textElement.style.display == 'none' ? 'block' : 'none';
  }

  /**
   * テキストのスタイル部分
   */
  private setTextStyle(textElement: HTMLElement): HTMLElement {
    const { itemInfo } = this.parentObj;
    const ua = marietta.webcad.WebCADGlobal.userAgentManager;
    const isPC = !ua.isTablet && !ua.isMobile;
    textElement.style.fontSize = isPC ? '3px' : '10px';
    textElement.style.color = itemInfo.text_color;
    textElement.style.fontFamily = marietta.webcad.WebCADGlobal.freeTextFontFamily;

    if (itemInfo.is_italic) {
      textElement.style.fontStyle = 'italic';
    }
    if (itemInfo.is_bold) {
      textElement.style.fontWeight = 'bold';
    }
    if (itemInfo.is_underline) {
      textElement.style.textDecoration = 'underline';
    }
    if (itemInfo.is_strike_through) {
      textElement.style.textDecoration = 'line-through';
    }
    textElement.style.textAlign = itemInfo.text_alignment;

    // スクロール
    if (itemInfo.text_alignment === 'center') {
      const scrollto = (textElement.scrollWidth - textElement.clientWidth) / 2;
      textElement.scrollLeft = scrollto;
    } else if (itemInfo.text_alignment === 'right') {
      const scrollto = (textElement.scrollWidth - textElement.clientWidth);
      textElement.scrollLeft = scrollto;
    }

    return textElement;
  }

  /**
   * 付帯工事情報
   * @returns
   */
  public createInfoElement(): HTMLElement {
    const { itemInfo } = this.parentObj;
    const infoWrap: HTMLElement = document.createElement('div');
    infoWrap.setAttribute('class', 'infoWrap');

    let contents = '<div class="infoHeaderWrap">';
    // マスター
    contents += this.createMasterList();

    const disabled = `${this.view_mode ? 'disabled' : ''}`;
    if (itemInfo?.auxiliaryData?.auxiliaryDatum?.estimatedEntryFlg === 1) {
      contents += `<label><input type="checkbox" id="checkInclude_${itemInfo.guid}" ${disabled} checked>見積算入</label>`;
    } else {
      contents += `<label><input type="checkbox" id="checkInclude_${itemInfo.guid}" ${disabled}>見積算入</label>`;
    }
    if (!this.view_mode) {
      contents += '<div class="pinItemBtnWrap">';
      contents += `<button id="btnChangeItem_${itemInfo.guid}" class="pinChangeItem">紐づけアイテム変更</button>`;
      contents += `<button id="btnDeleteItem_${itemInfo.guid}" class="pinDeleteItem">紐づけアイテム削除</button>`;
      contents += '</div>';
    }
    contents += `<!--<button id="btnComplete_${itemInfo.guid}" class="complete">入力完了</button>-->`;
    contents += '</div>';

    contents += '<div class="infoTableWrap">';
    contents += `<table id="itemListTable_${itemInfo.guid}" class="itemListTable defaultTable">`;

    // 付帯工事名検索
    contents += this.createSearchConstructionListView();

    // 中項目
    contents += this.createMediumListView();

    // 細項目
    contents += this.createSubItemListView();

    // 付帯工事名
    contents += this.createConstructionListView();

    // 数量
    contents += this.createQuantityView();

    // 単位
    contents += this.createUnitView();

    // 単価
    contents += this.createUnitPriceView();

    // 見積金額
    contents += this.createEstimatePriceView();

    // 入居者負担割合
    contents += this.createBurdenView();

    // 修繕理由
    contents += this.createReasonListView();

    contents += '</tbody>';
    contents += '</table>';
    contents += '</div>';

    infoWrap.insertAdjacentHTML('beforeend', contents);
    return infoWrap;
  }

  /**
   *カテゴリ
   * @returns
   */
  createMaster() {
    const { itemInfo } = this.parentObj;
    // 中項目
    let contents = '<tr>';
    contents += '<th class="masterItem"><span class="jp">マスタ種類</span><span class="en">Master</span></th>';
    contents += '<td class="masterItem">';
    contents += `<div id="masterItemBox_${itemInfo.guid}" class="viewMode">${itemInfo.auxiliaryData && itemInfo.auxiliaryData.auxiliaryDatum ? itemInfo.auxiliaryData.auxiliaryDatum.masterType : ''}</div>`;
    contents += `<select id="masterItem_${itemInfo.guid}" name="mediumItem_${itemInfo.guid}" class="editMode">`;
    contents += this.createMasterList();
    contents += '</select>';
    contents += '</td>';
    contents += '</tr>';
    return contents;
  }

  /**
   *中項目html 作成
   * @returns
   */
  createSearchConstructionListView() {
    // 付帯工事名
    let contents = '<tr>';
    contents += '<th class="nameSearch"><span class="jp">付帯工事名から検索</span><span class="en">Search for Name</span></th>';
    contents += '<td class="nameSearch">';
    contents += '<div id="nameSearchWrap">';
    contents += '<input id="nameSearch" name="nameSearch" value="">';
    contents += '<button type="button" id="nameSearchClearBtn"><i class="icon icon-close3"></i></button>';
    contents += '<button type="button" id="nameSearchBtn" name="nameSearchBtn"></button>';
    contents += '</div>';
    contents += '<div id="nameSearchListBox">';
    contents += '<ul id="nameSearchList">';
    contents += '</ul>';
    contents += '</div>';
    contents += '</td>';
    contents += '</tr>';
    return contents;
  }

  /**
   *中項目html 作成
   * @returns
   */
  createMediumListView() {
    const { itemInfo } = this.parentObj;
    // 中項目
    let contents = '<tr>';
    contents += '<th class="mediumItem"><span class="jp">中項目</span><span class="en">Medium Item</span></th>';
    contents += '<td class="mediumItem">';
    contents += `<div id="mediumItemBox_${itemInfo.guid}" class="viewMode">${itemInfo.auxiliaryData && itemInfo.auxiliaryData.auxiliaryDatum ? itemInfo.auxiliaryData.auxiliaryDatum.middleCategory : ''}</div>`;
    contents += `<select id="mediumItem_${itemInfo.guid}" name="mediumItem_${itemInfo.guid}" class="editMode">`;
    contents += this.createMediumList();
    contents += '</select>';
    contents += '</td>';
    contents += '</tr>';
    return contents;
  }

  /**
   *細項目html 作成
   * @returns
   */
  createSubItemListView() {
    const { itemInfo } = this.parentObj;
    // 細項目
    let contents = '<tr>';
    contents += '<th class="subitem"><span class="jp">細項目</span><span class="en">Subitem</span></th>';
    contents += '<td class="subitem">';
    contents += `<div id="subitemBox_${itemInfo.guid}" class="viewMode">${itemInfo.auxiliaryData && itemInfo.auxiliaryData?.auxiliaryDatum ? itemInfo.auxiliaryData.auxiliaryDatum.subCategory : ''}</div>`;
    contents += `<select id="subitem_${itemInfo.guid}" name="subitem_${itemInfo.guid}" class="editMode">`;
    contents += this.createSubCategoryListHtml();
    contents += '</select>';
    contents += '</td>';
    contents += '</tr>';
    return contents;
  }

  /**
   *付帯工事名html 作成
   * @returns
   */
  createConstructionListView() {
    const { itemInfo } = this.parentObj;
    // 付帯工事名
    let contents = '<tr>';
    contents += '<th class="name"><span class="jp">付帯工事名</span><span class="en">Name of Incidental Work</span></th>';
    contents += '<td class="name">';
    if (this.view_mode && itemInfo?.auxiliaryData?.auxiliaryDatum?.other_flag) {
      contents += `<div id="constructionBox_${itemInfo.guid}" class="viewMode">${itemInfo.auxiliaryData?.auxiliaryDatum ? itemInfo.auxiliaryData.auxiliaryDatum.otherText : ''}</div>`;
    } else {
      contents += `<div id="constructionBox_${itemInfo.guid}" class="viewMode">${itemInfo.auxiliaryData && itemInfo.auxiliaryData.auxiliaryDatum ? itemInfo.auxiliaryData.auxiliaryDatum.construction : ''}</div>`;
    }
    contents += `<select id="construction_${itemInfo.guid}" name="construction_${itemInfo.guid}" class="editMode">`;
    contents += this.createConstructionListHtml();
    contents += '</select>';
    contents += `<input id="construction_${itemInfo.guid}_other" name="construction_${itemInfo.guid}_other" value="${itemInfo.auxiliaryData?.auxiliaryDatum ? itemInfo.auxiliaryData.auxiliaryDatum.otherText : 'aa'}" class="editMode nameOther" type="text">`;
    contents += '</td>';
    contents += '</tr>';
    return contents;
  }

  /**
   * 数量html 作成
   * @returns
   */
  createQuantityView(): string {
    const { itemInfo } = this.parentObj;
    // 数量
    let contents = '<tr>';
    contents += '<th class="quantity"><span class="jp">数量</span><span class="en">Quantity</span></th>';
    contents += '<td class="quantity">';
    contents += `<div id="quantityBox_${itemInfo.guid}" class="viewMode">${itemInfo.auxiliaryData && itemInfo.auxiliaryData.auxiliaryDatum ? itemInfo.auxiliaryData.auxiliaryDatum.quantity : ''}</div>`;
    contents += `<input id="quantity_${itemInfo.guid}" name="quantity_${itemInfo.guid}" type="number" value="${itemInfo.auxiliaryData && itemInfo.auxiliaryData?.auxiliaryDatum ? itemInfo.auxiliaryData.auxiliaryDatum.quantity : ''}" class="editMode" type="number">`;
    contents += '</td>';
    contents += '</tr>';
    return contents;
  }

  /**
   * 単位html 作成
   * @returns
   */
  createUnitView(): string {
    const { itemInfo } = this.parentObj;
    // 単位
    let contents = '<tr>';
    contents += '<th class="unit"><span class="jp">単位</span><span class="en">Unit</span></th>';
    contents += '<td class="unit">';
    contents += `<div id="unitBox_${itemInfo.guid}" class="viewMode">${itemInfo.auxiliaryData && itemInfo.auxiliaryData?.auxiliaryDatum ? itemInfo.auxiliaryData.auxiliaryDatum.unit : ''}</div>`;
    contents += `<input id="dlg_unit_${itemInfo.guid}" name="dlg_unit_${itemInfo.guid}" value="${itemInfo.auxiliaryData && itemInfo.auxiliaryData?.auxiliaryDatum ? itemInfo.auxiliaryData.auxiliaryDatum.unit : ''}" class="editMode" type="text">`;
    contents += '</td>';
    contents += '</tr>';
    return contents;
  }

  /**
   * 単価html 作成
   * @returns
   */
  createUnitPriceView(): string {
    const { itemInfo } = this.parentObj;
    // 単価
    let contents = '<tr>';
    contents += '<th class="unitPrice"><span class="jp">単価</span><span class="en">Unit Price</span></th>';
    contents += '<td class="unitPrice">';
    contents += `<div id="unitPriceBox_${itemInfo.guid}" class="viewMode">${itemInfo.auxiliaryData && itemInfo.auxiliaryData?.auxiliaryDatum ? itemInfo.auxiliaryData.auxiliaryDatum.unitPrice : ''}</div>`;
    contents += `<input id="unitPrice_${itemInfo.guid}" name="unitPrice_${itemInfo.guid}" type="number" value="${itemInfo.auxiliaryData && itemInfo.auxiliaryData?.auxiliaryDatum ? itemInfo.auxiliaryData.auxiliaryDatum.unitPrice : ''}" class="editMode" type="number">`;
    contents += '円';
    contents += '</td>';
    contents += '</tr>';
    return contents;
  }

  /**
   * 見積金額html 作成
   * @returns
   */
  createEstimatePriceView(): string {
    const { itemInfo } = this.parentObj;
    // 見積金額
    let contents = '<tr>';
    contents += '<th class="estimatedPrice"><span class="jp">見積金額</span><span class="en">Estimated Price</span></th>';
    contents += '<td class="estimatedPrice">';
    contents += `<div id="estimatedPriceBox_${itemInfo.guid}" class="viewMode">${itemInfo.auxiliaryData && itemInfo.auxiliaryData?.auxiliaryDatum ? itemInfo.auxiliaryData.auxiliaryDatum.totalPrice : ''}</div>`;
    contents += `<input id="estimatedPrice_${itemInfo.guid}" name="estimatedPrice_${itemInfo.guid}" value="${itemInfo.auxiliaryData && itemInfo.auxiliaryData?.auxiliaryDatum ? itemInfo.auxiliaryData.auxiliaryDatum.totalPrice : ''}" class="editMode" type="text" disabled>`;
    contents += '円';
    contents += '</td>';
    contents += '</tr>';
    return contents;
  }

  /**
   * 入居者負担割合html 作成
   * @returns
   */
  createBurdenView(): string {
    const { itemInfo } = this.parentObj;
    // 入居者負担割合
    let contents = '<tr>';
    contents += '<th class="burden"><span class="jp">入居者負担割合</span><span class="en">Burden</span></th>';
    contents += '<td class="burden">';
    contents += `<div id="burdenBox_${itemInfo.guid}" class="viewMode">${itemInfo.auxiliaryData && itemInfo.auxiliaryData?.auxiliaryDatum ? itemInfo.auxiliaryData.auxiliaryDatum.rate * 100 : ''}</div>`;
    contents += `<input id="burden_${itemInfo.guid}" name="burden_${itemInfo.guid}" type="number" min="0" max="100" step="1" value="${itemInfo.auxiliaryData && itemInfo.auxiliaryData?.auxiliaryDatum ? itemInfo.auxiliaryData.auxiliaryDatum.rate * 100 : ''}" class="editMode">`;
    contents += '%';
    contents += '</td>';
    contents += '</tr>';
    return contents;
  }

  /**
   * 修繕理由html 作成
   * @returns
   */
  createReasonListView(): string {
    const { itemInfo } = this.parentObj;
    // 修繕理由
    let contents = '<tr>';
    contents += '<th class="reason"><span class="jp">修繕理由</span><span class="en">Reason for Repair</span></th>';
    contents += '<td class="reason">';
    contents += `<div id="reasonBox_${itemInfo.guid}" class="viewMode">${itemInfo.auxiliaryData && itemInfo.auxiliaryData?.auxiliaryDatum ? itemInfo.auxiliaryData.auxiliaryDatum.repair : ''}</div>`;
    contents += `<select id="dialog_reason_${itemInfo.guid}" name="dialog_reason_${itemInfo.guid}" class="editMode">`;
    contents += this.createReasonList();
    contents += '</select>';
    contents += '</td>';
    return contents;
  }

  /**
   * 備考html 作成
   * @returns
   */
  createRemarkView(): HTMLDivElement {
    const { itemInfo } = this.parentObj;
    // 備考
    const temp = document.createElement('div');
    temp.setAttribute('class', 'remarksWrap');
    // remarksにはindex道理に並んでいない可能性があるのでidで取得
    const id = itemInfo.link[0].id;
    const matchedRemark = (itemInfo.remarks.length > 0) ? itemInfo.remarks.find(remark => remark.id === id)?.text : null;
    const remark = matchedRemark ?? itemInfo?.auxiliaryData?.auxiliaryDatum?.remarks;
    const contents = `
      <div class="remarks"><span class="jp">備考</span><span class="en">Remarks</span></div>
      <div class="remarks remarksBoxWrap">
        <textarea id="dialog_remarks_${itemInfo.guid}" name="dialog_remarks_${itemInfo.guid}" class="editMode" rows="5">${remark ?? ''}</textarea>
      </div>
    `;
    temp.innerHTML = contents;
    return temp;
  }

  /**
   * 左右矢印ボタンhtml 作成
   */
  createArrowBtnsView(): HTMLDivElement {
    const temp = document.createElement('div');
    temp.className = 'arrowBtnsWrap';
    // 現在の数
    this.currentNumber = 1;

    const contents = `
      <div class="arrow" id="arrowLeft">◀</div>&nbsp;
      <div id="currentIndex">${this.currentNumber}</div>
      <span>&nbsp;/&nbsp;</span>
      <div id="totalCount">${this.totalCount}</div>&nbsp;
      <div class="arrow" id="arrowRight">▶</div>
    `;

    temp.innerHTML = contents;
    return temp;
  }

  /**
   * 左矢印ボタンイベント
   */
  private leftArrowEvent = () => {
    const addNum = -1; // 前のインデックスに戻る
    this.addCurrentNumber(addNum)
  }

  /**
   * 右矢印ボタンイベント
   */
  private rightArrowEvent = () => {
    const addNum = 1; // 次のインデックスに進む
    this.addCurrentNumber(addNum);
  }

  /**
   * 現在表示中のインデックス番号の更新
   */
  private updateCurrentIndex(newIndex: number) {
    const div = document.getElementById('currentIndex');
    if(!div) return;
    div.textContent = newIndex.toString();
  }

  /**
   * 備考の更新
   */
  private updateRemarkView(id: string, prevId?: string): void {
    const { itemInfo } = this.parentObj;
    const textarea = document.getElementById(`dialog_remarks_${itemInfo.guid}`) as HTMLTextAreaElement | null;
    if (!textarea || !itemInfo.remarks?.find(remark => remark.id === id)) return;

    const text = itemInfo.remarks.find(remark => remark.id === id)?.text;
    const value = textarea.value;
    if (typeof text === "string") {
      textarea.value = text;
    }
    if(!prevId) return;
    const prevRemarkView = itemInfo.remarks.find(remark => remark.id === prevId);
    if(prevRemarkView) {
      prevRemarkView.text = value;
    }
  }

  /**
   * NoImage を表示する共通処理
   */
  private showNoImage(container: HTMLElement, maxWidth: number, maxHeight: number): void {
    // 既存画像を削除
    container.innerHTML = "";

    const noImage = document.createElement("img");
    noImage.id = "noImage";
    noImage.src = `${marietta.webcad.WebCADGlobal.webcad2Dmanager.assets_url}/noImage.png`;
    noImage.style.maxWidth = `${maxWidth}px`;
    noImage.style.maxHeight = `${maxHeight}px`;
    // 代替画像が読み込まれた際の処理
    noImage.addEventListener('load', (e: Event) => {
      (<HTMLImageElement>e.target).style.maxWidth = `${maxWidth}px`;
      (<HTMLImageElement>e.target).style.maxHeight = `${maxHeight}px`;
    }, { once: true }); // 一度だけ発火
    container.appendChild(noImage);
  }

  /**
   * 汎用的に画像を更新（エラーハンドリング付き）
   */
  private updateImageView(
    containerId: string,
    guid: string,
    urlList: LinkType[],     // itemInfo.link / itemInfo.after_link
    id: string,
    width: number,
  ): void {
    const container = document.getElementById(`${containerId}_${guid}`);
    if (!container) return;
    container.innerHTML = "";
    const maxWidth = width - 20; // margin分を引く
    const viewHeight = 180; // imgの表示領域 190px(linkWrap) - 10px(textWrap margin)
    const maxHeight = viewHeight - 30; // margin分引く
    // URLがない場合はNoImageを表示
    const target = urlList[this.currentNumber - 1];
    const url = target?.url;
    const binary = target?.binary;
    if (!url && !binary) {
      if(containerId === "imgAfter") {
        this.createBtnDocElement();
        this.setAfterImageEvent();
      }
      return;
    }
  
    // aタグの用意
    const aTag = this.ensureAnchor(container, url);

    // imgの用意
    const img = this.ensureImage(aTag, maxWidth, maxHeight);

    const imgUrl = binary ?? url;
    // src設定
    img.setAttribute('src', imgUrl);
    if(containerId === "imgAfter") {
      const deleteBtn = this.createDeleteDocumentBtn(guid);
      container.appendChild(deleteBtn);
    }
  
    // エラーハンドリング設定
    img.onerror = () => this.showNoImage(container, maxWidth, maxHeight);
  }
  
  /**
   * コンテナ内に aタグを用意（なければ作成）
   */
  private ensureAnchor(container: HTMLElement, href: string): HTMLAnchorElement {
    let aTag = container.querySelector("a") as HTMLAnchorElement | null;
    if (!aTag) {
      const noImg = container.querySelector("#noImage");
      if (noImg) noImg.remove();
    
      aTag = document.createElement("a");
      aTag.target = "_blank";
      container.appendChild(aTag);
    }
    aTag.href = href;
    return aTag;
  }
  
  /**
   * aタグ内に img を用意（なければ作成）
   */
  private ensureImage(aTag: HTMLAnchorElement, maxWidth: number, maxHeight: number): HTMLImageElement {
    let img = aTag.querySelector(".pinImg") as HTMLImageElement | null;
    if (!img) {
      img = document.createElement("img");
      img.className = "pinImg";
      img.style.maxWidth = `${maxWidth}px`;
      img.style.maxHeight = `${maxHeight}px`;
      aTag.appendChild(img);
    }
    return img;
  }

  /**
   * Before写真の更新
   */
  private updateBeforeView(id: string): void {
    const { itemInfo } = this.parentObj;
    const width = this.parentObj.getWidth();
    this.updateImageView(`imgBefore`, itemInfo.guid, itemInfo.link, id, width);
  }

  /**
   * After写真の更新
   */
  private updateAfterView(id: string): void {
    const { itemInfo } = this.parentObj;
    const width = this.parentObj.getWidth();
    this.updateImageView(`imgAfter`, itemInfo.guid, this.afterImage, id, width);
  }

  /**
   *
   * @returns
   */
  createReasonList(): string {
    let contents = '';
    if (marietta.webcad.WebCADGlobal.REPAIR_MASTER?.repair_reasons) {
      contents += `<option value=""></option>`; // 空選択追加
      for (let i: number = 0; i < marietta.webcad.WebCADGlobal.REPAIR_MASTER.repair_reasons.length; i += 1) {
        contents += `<option value="${marietta.webcad.WebCADGlobal.REPAIR_MASTER.repair_reasons[i].name}" data-id="${marietta.webcad.WebCADGlobal.REPAIR_MASTER.repair_reasons[i].id}">${marietta.webcad.WebCADGlobal.REPAIR_MASTER.repair_reasons[i].name}</option>`;
      }
    }
    return contents;
  }

  // /**
  //  * デフォルト/企業
  //  */
  // private getMasterType(constructureID: string): number {
  //   const isDefault = marietta.webcad.WebCADGlobal.AUXILIARY_MASTER.default?.some((data) => {
  //     return data?.sub_categories.some((sumCategory) => {
  //       return sumCategory.auxiliary_constructions?.some((construction) => {
  //         return construction?.id === constructureID;
  //       });
  //     });
  //   });

  //   if (isDefault) {
  //     return MasterType.Default;
  //   }
  //   return MasterType.Company;
  // }

  /**
   *
   */
  createMasterList(): string {
    const masterType = this.parentObj?.itemInfo?.auxiliaryData?.auxiliaryDatum?.masterType;
    this.selectedMaster = masterType ?? 1;
    const disabled = `${this.view_mode ? 'disabled' : ''}`;
    let contents = '<div class="btnWrap">';
    contents += `<input id="masterDefault" type="radio" name="masterSelect" value="0" ${disabled} ${this.selectedMaster === MasterType.Default ? 'checked' : ''}><label for="masterDefault">デフォルト</label>`;
    contents += `<input id="masterCompany" type="radio" name="masterSelect" value="1" ${disabled} ${this.selectedMaster === MasterType.Default ? '' : 'checked'}><label for="masterCompany">企業</label>`;
    contents += '</div>';

    return contents;
  }

  /**
   *
   * @returns
   */
  createMediumList(): string {
    let contents = '';
    if (this.selectedMaster === MasterType.Company && marietta.webcad.WebCADGlobal.AUXILIARY_MASTER?.company) {
      this.middleCategoryList = marietta.webcad.WebCADGlobal.AUXILIARY_MASTER.company;
    }
    if (this.selectedMaster === MasterType.Default && marietta.webcad.WebCADGlobal.AUXILIARY_MASTER?.default) {
      this.middleCategoryList = marietta.webcad.WebCADGlobal.AUXILIARY_MASTER.default;
    }

    // "その他設備" を最後に移動する処理
    const sortMiddleCategoryList = [...this.middleCategoryList].sort((a, b) => {
      if (a.middle_category_name === 'その他設備') return 1; // "その他設備" を後ろに移動
      if (b.middle_category_name === 'その他設備') return -1;
      return 0; // 他は順序を維持
    });
    // for (let i: number = 0; i < this.middleCategoryList.length; i += 1) {
    //   contents += `<option value="${this.middleCategoryList[i].middle_category_name}">${this.middleCategoryList[i].middle_category_name}</option>`;
    // }
      contents += `<option value=""></option>`; // 空選択追加
    for (let i: number = 0; i < sortMiddleCategoryList.length; i += 1) {
      contents += `<option value="${sortMiddleCategoryList[i].middle_category_name}">${sortMiddleCategoryList[i].middle_category_name}</option>`;
    }
    return contents;
  }

  /**
   *サブカテゴリリスト
   */
  createSubCategoryListHtml(): string {
    let contents = '';
    if (this.middleCategoryList.length > 0) {
      const middleListValue = this.middleCategoryList[0].middle_category_name;
      const selectedDataSet = this.middleCategoryList.find((item) => item.middle_category_name === middleListValue);
      this.subCategoryList = selectedDataSet?.sub_categories ? selectedDataSet.sub_categories : [];
      if (selectedDataSet) {
        contents += `<option value=""></option>`; // 空選択追加
        for (let i: number = 0; i < selectedDataSet.sub_categories.length; i += 1) {
          contents += `<option value="${selectedDataSet.sub_categories[i].sub_category_name}">${selectedDataSet.sub_categories[i].sub_category_name}</option>`;
        }
      }
    }
    return contents;
  }

  /**
   *
   */
  createConstructionListHtml(): string {
    let contents = '';
    if (this.subCategoryList.length > 0) {
      const { itemInfo } = this.parentObj;
      const subCategoryValue = this.subCategoryList[0].sub_category_name;
      const selectedDataSet = this.subCategoryList.find((item) => item.sub_category_name === subCategoryValue);
      if (document.getElementById(`construction_${itemInfo.guid}`)) {
        (document.getElementById(`construction_${itemInfo.guid}`) as HTMLSelectElement).innerHTML = '';
      }
      if (selectedDataSet) {
        if (selectedDataSet.auxiliary_constructions.length > 0) {
          this.selectedConstruction = selectedDataSet.auxiliary_constructions[0];
        }
        contents += `<option value=""></option>`; // 空選択追加
        for (let i: number = 0; i < selectedDataSet.auxiliary_constructions.length; i += 1) {
          const option: HTMLOptionElement = document.createElement('option') as HTMLOptionElement;
          option.textContent = selectedDataSet.auxiliary_constructions[i].name;
          option.value = selectedDataSet.auxiliary_constructions[i].name;
          option.setAttribute('data-other-flag', selectedDataSet.auxiliary_constructions[i].other_flag.toString());
          option.setAttribute('data-unit-price', selectedDataSet.auxiliary_constructions[i].unit_price.toString());
          option.setAttribute('data-unit', selectedDataSet.auxiliary_constructions[i].unit);
          option.setAttribute('data-id', selectedDataSet.auxiliary_constructions[i].id);
          contents += option.outerHTML;
        }
      }
    }
    return contents;
  }

  /**
   * HTML 要素イベントアクションを作成する
   */
  createEventListner() {
    this.initData();

    const { itemInfo } = this.parentObj;

    // リストのイベント
    this.setListEvents();

    // 数量が変わったときの処理
    if (document.getElementById(`quantity_${itemInfo.guid}`)) {
      document.getElementById(`quantity_${itemInfo.guid}`).addEventListener('change', this.quantityAndUnitPriceInputEvent);
    }
    // 数量が変わったときの処理
    if (document.getElementById(`unitPrice_${itemInfo.guid}`)) {
      document.getElementById(`unitPrice_${itemInfo.guid}`).addEventListener('change', this.quantityAndUnitPriceInputEvent);
    }
    if (document.getElementById(`btnBefore_${itemInfo.guid}`)) {
      document.getElementById(`btnBefore_${itemInfo.guid}`).addEventListener('click', this.onBtnBeforeEvent);
    }
    if (document.getElementById(`btnAfter_${itemInfo.guid}`)) {
      document.getElementById(`btnAfter_${itemInfo.guid}`).addEventListener('click', this.onBtnAfterEvent);
    }
    // after画像のイベント
    this.setAfterImageEvent();

    if (document.getElementById(`btnGetDoc_${itemInfo.guid}`)) {
      document.getElementById(`btnGetDoc_${itemInfo.guid}`).addEventListener('click', this.btnGetDocHandler);
    }
    // After画像削除
    if (document.getElementById(`btnDocDelete_${itemInfo.guid}`)) {
      document.getElementById(`btnDocDelete_${itemInfo.guid}`).addEventListener('click', this.deleteDocument);
    }
    // 矢印のイベント
    if (document.getElementById('arrowLeft')) {
      document.getElementById('arrowLeft').addEventListener('click', this.leftArrowEvent);
    }
    if (document.getElementById('arrowRight')) {
      document.getElementById('arrowRight').addEventListener('click', this.rightArrowEvent);
    }

    // 見積参入
    if (document.getElementById(`checkInclude_${itemInfo.guid}`)) {
      document.getElementById(`checkInclude_${itemInfo.guid}`).addEventListener('change', this.onChangeIncludeCheck);
    }

    // 付帯工事検索ボックスのリセットボタンの表示非表示
    if (document.getElementById('nameSearch')) {
      document.getElementById('nameSearch').addEventListener('focus', this.focusNameSearch);
      document.getElementById('nameSearch').addEventListener('input', this.onChangeNameSearch);
      // document.getElementById('nameSearch').addEventListener('blur', this.blurNameSearch);
    }

    // リセットボタン押下で検索ボックスを空に
    if (document.getElementById('nameSearchClearBtn')) {
      document.getElementById('nameSearchClearBtn').addEventListener('click', this.nameSearchClear);
    }

    // リストを選択
    if (document.getElementById('nameSearchList')) {
      document.getElementById('nameSearchList').addEventListener('click', this.onSetName);
    }

    const options: ValidateOptions = {
      minMax: { min: 0, max: 999999 },
      numericFilter: true,
      isFloat: true,
      maxLength: 0,
    };
    // 数量
    if (document.getElementById(`quantity_${itemInfo.guid}`)) {
      const quantityOptions = { ...options, minMaxCallBack: this.quantityAndUnitPriceInputEvent };
      marietta.webcad.util.InputValidationUtil.setValidation((<HTMLInputElement>document.getElementById(`quantity_${itemInfo.guid}`)), quantityOptions);
    }
    // 単価
    const unitPrice = (<HTMLInputElement>document.getElementById(`unitPrice_${itemInfo.guid}`));
    unitPrice.addEventListener('focus', () => {
      unitPrice.value = unitPrice.value.replace(/,/g, '');
      unitPrice.setAttribute('type', 'number');
    });
    const unitPriceCallBack = () => {
      this.insertComma(unitPrice);
      this.quantityAndUnitPriceInputEvent();
    };
    if (unitPrice) {
      const unitPriceOptions = { ...options, minMaxCallBack: unitPriceCallBack, isFloat: false };
      marietta.webcad.util.InputValidationUtil.setValidation(unitPrice, unitPriceOptions);
    }
    // 入居者負担割合
    if (document.getElementById(`burden_${itemInfo.guid}`)) {
      marietta.webcad.util.InputValidationUtil.setValidation((<HTMLInputElement>document.getElementById(`burden_${itemInfo.guid}`)), { ...options, minMax: { min: 0, max: 100 }, isFloat: false });
    }

    // デフォルト
    document.getElementById('masterDefault')?.addEventListener('change', (e) => {
      // 現在の設定を保持する
      this.saveCurrentAuxiliaryData();

      if ((<HTMLInputElement>e.target).checked) this.selectedMaster = MasterType.Default;

      this.changeMaster();
    });
    // 企業
    document.getElementById('masterCompany')?.addEventListener('change', (e) => {
      // 現在の設定を保持する
      this.saveCurrentAuxiliaryData();

      if ((<HTMLInputElement>e.target).checked) this.selectedMaster = MasterType.Company;

      this.changeMaster();
    });

    // 現在の設定を保持する
    this.saveCurrentAuxiliaryData();
  }

  /** 3桁以上の時、カンマをつける */
  private insertComma(element: HTMLInputElement): void {
    if (!element) return;

    element.setAttribute('type', 'text');
    if (String(element.value).length > 3) {
      element.value = Number(element.value).toLocaleString(); // 3桁ごとにカンマ区切りに変換する
    }
  }

  /**
   * リストのイベントを設定
   */
  setListEvents():void {
    const { itemInfo } = this.parentObj;
    // カテゴリリスト
    if (document.getElementById(`mediumItem_${itemInfo.guid}`)) {
      document.getElementById(`mediumItem_${itemInfo.guid}`).addEventListener('change', this.onMiddleCategorySelected);
    }
    // サブカテゴリリスト
    if (document.getElementById(`subitem_${itemInfo.guid}`)) {
      document.getElementById(`subitem_${itemInfo.guid}`).addEventListener('change', () => this.onSubCategorySelected(false));
    }

    // プルダウンが変わったときの処理
    if (document.getElementById(`construction_${itemInfo.guid}`)) {
      document.getElementById(`construction_${itemInfo.guid}`).addEventListener('change', () => this.onConstructionSelected(false));
    }
  }

  /**
   * after画像周りのイベント
   */
  private setAfterImageEvent() {
    const { itemInfo } = this.parentObj;
    // カメラ起動
    if (document.getElementById(`${this.afterBtnBaseId}_${itemInfo.guid}`)) {
      document.getElementById(`${this.afterBtnBaseId}_${itemInfo.guid}`).addEventListener('click', this.cameraStartEvent);
    }
    // カメラロール
    if (document.getElementById(`openCameraRool_${itemInfo.guid}`)) {
      document.getElementById(`openCameraRool_${itemInfo.guid}`).addEventListener('click', this.cameraRollStartEvent);
    }
    // 企画ドキュメント
    if (document.getElementById(`openDoc_${itemInfo.guid}`)) {
      document.getElementById(`openDoc_${itemInfo.guid}`).addEventListener('click', this.btnGetDocHandler);
    }
  }

  /** マスタラジオボタン切り替え時の処理 */
  private changeMaster() {
    const { itemInfo } = this.parentObj;
    // 中項目
    document.getElementById(`mediumItem_${itemInfo.guid}`).innerHTML = '';
    document.getElementById(`mediumItem_${itemInfo.guid}`).insertAdjacentHTML('beforeend', this.createMediumList());
    // 細項目
    document.getElementById(`subitem_${itemInfo.guid}`).innerHTML = '';
    document.getElementById(`subitem_${itemInfo.guid}`).insertAdjacentHTML('beforeend', this.createSubCategoryListHtml());
    // 付帯工事名
    document.getElementById(`construction_${itemInfo.guid}`).innerHTML = '';
    document.getElementById(`construction_${itemInfo.guid}`).insertAdjacentHTML('beforeend', this.createConstructionListHtml());
    // 付帯工事名その他の表示制御
    this.onConstructionSelected(false);

    // 各データの初期設定を前回の選択に戻す
    this.initAuxiliaryDataList();
  }

  public initData() {
    const { itemInfo } = this.parentObj;
    let quantity: number = NaN;
    let unit: string = '';
    let unitPrice: number = NaN;
    let estimatedPrice: number = NaN;
    let rate: number = 0;
    if (itemInfo.auxiliaryData && itemInfo.auxiliaryData.auxiliaryDatum) {
      quantity = itemInfo.auxiliaryData.auxiliaryDatum.quantity ? itemInfo.auxiliaryData.auxiliaryDatum.quantity : NaN;
      unit = itemInfo.auxiliaryData.auxiliaryDatum.unit ? itemInfo.auxiliaryData.auxiliaryDatum.unit : '';
      unitPrice = itemInfo.auxiliaryData.auxiliaryDatum.unitPrice ? itemInfo.auxiliaryData.auxiliaryDatum.unitPrice : NaN;
      estimatedPrice = itemInfo.auxiliaryData.auxiliaryDatum.totalPrice ? itemInfo.auxiliaryData.auxiliaryDatum.totalPrice : NaN;
      rate = itemInfo.auxiliaryData.auxiliaryDatum.rate ? itemInfo.auxiliaryData.auxiliaryDatum.rate * 100 : NaN;
    } else if (this.selectedConstruction) {
      unit = this.selectedConstruction.unit;
      unitPrice = this.selectedConstruction.unit_price;
      estimatedPrice = Math.floor(unitPrice * quantity);
    }
    if (itemInfo.auxiliaryData?.auxiliaryDatum?.middleCategory) (document.getElementById(`mediumItem_${itemInfo.guid}`) as HTMLSelectElement).value = itemInfo.auxiliaryData.auxiliaryDatum.middleCategory;
    this.onMiddleCategorySelected().then(() => {
      if (itemInfo.auxiliaryData?.auxiliaryDatum?.subCategory) (document.getElementById(`subitem_${itemInfo.guid}`) as HTMLSelectElement).value = itemInfo.auxiliaryData.auxiliaryDatum.subCategory;
      this.onSubCategorySelected(true).then(() => {
        if (itemInfo.auxiliaryData?.auxiliaryDatum?.constructionId) {
          const constructionElem = (document.getElementById(`construction_${itemInfo.guid}`) as HTMLSelectElement);
          constructionElem.value = itemInfo.auxiliaryData?.auxiliaryDatum?.construction ?? '';
          if (constructionElem.value) return;
          // STARTS_LIDAR-1720 ピン情報 ライダーで登録した付帯工事名が表示されない
          const construction = this.constructionList.find((data) => data.id === itemInfo.auxiliaryData.auxiliaryDatum.constructionId);
          constructionElem.value = construction?.name ?? '';
        }
      });
    });
    (document.getElementById(`quantity_${itemInfo.guid}`) as HTMLInputElement).value = !Number.isNaN(quantity) ? quantity.toString() : '0';
    (document.getElementById(`unitPrice_${itemInfo.guid}`) as HTMLInputElement).value = !Number.isNaN(unitPrice) ? unitPrice.toString() : '0';
    (document.getElementById(`dlg_unit_${itemInfo.guid}`) as HTMLInputElement).value = unit;
    (document.getElementById(`estimatedPrice_${itemInfo.guid}`) as HTMLInputElement).value = !Number.isNaN(estimatedPrice) ? estimatedPrice.toString() : '0';

    (document.getElementById(`burden_${itemInfo.guid}`) as HTMLInputElement).value = !Number.isNaN(rate) ? rate.toString() : '0';

    if (itemInfo.auxiliaryData?.auxiliaryDatum?.repair) (document.getElementById(`dialog_reason_${itemInfo.guid}`) as HTMLSelectElement).value = itemInfo.auxiliaryData.auxiliaryDatum.repair;
  }

  public initAuxiliaryDataList=() => {
    // 保持をする
    if (this.selectedMaster) {
      console.log('this.listSelection.company');
      console.log(this.listSelection.company);
      if (this.listSelection.company?.middle) {
        (document.getElementById(`mediumItem_${this.parentObj.itemInfo.guid}`) as HTMLSelectElement).value = this.listSelection.company.middle;
        this.onMiddleCategorySelected().then(() => {
          (document.getElementById(`subitem_${this.parentObj.itemInfo.guid}`) as HTMLSelectElement).value = this.listSelection.company.subCategory;
          this.onSubCategorySelected().then(() => {
            (document.getElementById(`construction_${this.parentObj.itemInfo.guid}`) as HTMLSelectElement).value = this.listSelection.company.construction;
          });
        });
      }
    } else {
      console.log('this.listSelection.default');
      console.log(this.listSelection.default);
      if (this.listSelection.default?.middle) {
        (document.getElementById(`mediumItem_${this.parentObj.itemInfo.guid}`) as HTMLSelectElement).value = this.listSelection.default.middle;
        this.onMiddleCategorySelected().then(() => {
          (document.getElementById(`subitem_${this.parentObj.itemInfo.guid}`) as HTMLSelectElement).value = this.listSelection.default.subCategory;
          this.onSubCategorySelected().then(() => {
            (document.getElementById(`construction_${this.parentObj.itemInfo.guid}`) as HTMLSelectElement).value = this.listSelection.default.construction;
          });
        });
      }
    }
  }

  private saveCurrentAuxiliaryData():void {
    // 保持をする
    if (this.selectedMaster) {
      this.listSelection.company = { middle: null, subCategory: null, construction: null };
      this.listSelection.company.middle = (document.getElementById(`mediumItem_${this.parentObj.itemInfo.guid}`) as HTMLSelectElement).value;
      this.listSelection.company.subCategory = (document.getElementById(`subitem_${this.parentObj.itemInfo.guid}`) as HTMLSelectElement).value;
      this.listSelection.company.construction = (document.getElementById(`construction_${this.parentObj.itemInfo.guid}`) as HTMLSelectElement).value;
    } else {
      this.listSelection.default = { middle: null, subCategory: null, construction: null };
      this.listSelection.default.middle = (document.getElementById(`mediumItem_${this.parentObj.itemInfo.guid}`) as HTMLSelectElement).value;
      this.listSelection.default.subCategory = (document.getElementById(`subitem_${this.parentObj.itemInfo.guid}`) as HTMLSelectElement).value;
      this.listSelection.default.construction = (document.getElementById(`construction_${this.parentObj.itemInfo.guid}`) as HTMLSelectElement).value;
    }
  }

  /**
   * 数量が変わったときの処理
   * @param e
   */
  quantityAndUnitPriceInputEvent = () => {
    const { itemInfo } = this.parentObj;
    const quantityInput = document.getElementById(`quantity_${itemInfo.guid}`) as HTMLInputElement;
    const unitPriceInput = document.getElementById(`unitPrice_${itemInfo.guid}`) as HTMLInputElement;

    // 見積金額を計算
    const quantity = parseFloat(quantityInput.value) || 0; // デフォルト値を指定
    const unitPrice = parseFloat(unitPriceInput.value.replace(/,/g, '')) || 0;
    const estimatedPriceInput = document.getElementById(`estimatedPrice_${itemInfo.guid}`) as HTMLInputElement;
    const estimatedPrice = Math.floor(unitPrice * quantity);
    estimatedPriceInput.value = estimatedPrice.toString();
    this.insertComma(estimatedPriceInput);
  }

  /**
   * カテゴリが選択された
   * @param e
   */
  onMiddleCategorySelected = () => new Promise<void>((resolve) => {
    const { itemInfo } = this.parentObj;
    const selectedValue: string = (document.getElementById(`mediumItem_${itemInfo.guid}`) as HTMLSelectElement).value;
    this.createSubCategoryList(selectedValue);
    resolve();
  })

  /**
   *サブカテゴリリスト
   */
  createSubCategoryList(middleListValue: string) {
    const { itemInfo } = this.parentObj;
    const selectedDataSet = this.middleCategoryList.find((item) => item.middle_category_name === middleListValue);
    this.subCategoryList = selectedDataSet?.sub_categories ? selectedDataSet.sub_categories : [];
    (document.getElementById(`subitem_${itemInfo.guid}`) as HTMLSelectElement).innerHTML = '';
    if (selectedDataSet) {
      const optionNone: HTMLOptionElement = document.createElement('option') as HTMLOptionElement;
      optionNone.value = "";
      (document.getElementById(`subitem_${itemInfo.guid}`) as HTMLSelectElement).options.add(optionNone);

      for (let i: number = 0; i < selectedDataSet.sub_categories.length; i += 1) {
        const option: HTMLOptionElement = document.createElement('option') as HTMLOptionElement;
        option.textContent = selectedDataSet.sub_categories[i].sub_category_name;
        option.value = selectedDataSet.sub_categories[i].sub_category_name;
        (document.getElementById(`subitem_${itemInfo.guid}`) as HTMLSelectElement).options.add(option);
      }
    }
    // if (this.subCategoryList.length > 0) {
    // const sub_category_name = (this.subCategoryList.length > 0) ? this.subCategoryList[0].sub_category_name : null;
    const sub_category_name = ''; //未選択
    this.createConstructionList(sub_category_name, false);
    // }
  }

  /**
   * サブ・カテゴリが選択された
   * @param e
   */
  private onSubCategorySelected = (initData: boolean = false) => new Promise<void>((resolve) => {
    const { itemInfo } = this.parentObj;
    const selectedValue: string = (document.getElementById(`subitem_${itemInfo.guid}`) as HTMLSelectElement).value;
    const selectedDataSet = this.subCategoryList.find((item) => item.sub_category_name === selectedValue);
    // 工事リスト
    if (selectedDataSet) {
      this.constructionList = selectedDataSet.auxiliary_constructions;
      this.createConstructionList(selectedValue, initData);
    }
    resolve();
  })

  /**
   *付帯工事リスト
   */
  createConstructionList(constructionValue: string, initData: boolean) {
    const { itemInfo } = this.parentObj;
    const selectedDataSet = this.subCategoryList.find((item) => item.sub_category_name === constructionValue);
    (document.getElementById(`construction_${itemInfo.guid}`) as HTMLSelectElement).options.length = 0;
    if (selectedDataSet) {
      //その他の場合は空行追加しないで直接その他を選択状態とする
      if( selectedDataSet.auxiliary_constructions.length == 1 && selectedDataSet.auxiliary_constructions[0].other_flag == 1){

      } else {
        const optionNone: HTMLOptionElement = document.createElement('option') as HTMLOptionElement;
        optionNone.value = "";
        optionNone.setAttribute('data-other-flag', '0');
        (document.getElementById(`construction_${itemInfo.guid}`) as HTMLSelectElement).options.add(optionNone);
      }

      for (let i: number = 0; i < selectedDataSet.auxiliary_constructions.length; i += 1) {
        const option: HTMLOptionElement = document.createElement('option') as HTMLOptionElement;
        option.textContent = selectedDataSet.auxiliary_constructions[i].name;
        option.value = selectedDataSet.auxiliary_constructions[i].name;
        option.setAttribute('data-other-flag', selectedDataSet.auxiliary_constructions[i].other_flag.toString());
        option.setAttribute('data-unit-price', selectedDataSet.auxiliary_constructions[i].unit_price.toString());
        option.setAttribute('data-unit', selectedDataSet.auxiliary_constructions[i].unit);
        option.setAttribute('data-id', selectedDataSet.auxiliary_constructions[i].id);
        (document.getElementById(`construction_${itemInfo.guid}`) as HTMLSelectElement).options.add(option);
      }
      this.onConstructionSelected(initData);
    } else {
      const option: HTMLOptionElement = document.createElement('option') as HTMLOptionElement; // 空行選択
      (document.getElementById(`construction_${itemInfo.guid}`) as HTMLSelectElement).options.add(option);
    }
  }

  /**
   * サブ・カテゴリが選択された
   * @param e
   */
  private onConstructionSelected = (initData: boolean) => {
    const { itemInfo } = this.parentObj;
    const nameSelect = document.getElementById(`construction_${itemInfo.guid}`) as HTMLSelectElement;
    const selectedOption = nameSelect.options[nameSelect.selectedIndex];
    const unitPrice = parseFloat(selectedOption.getAttribute('data-unit-price') || '0'); // デフォルト値を指定
    const quantityInput = document.getElementById(`quantity_${itemInfo.guid}`) as HTMLInputElement;
    const estimatedPriceInput = document.getElementById(`estimatedPrice_${itemInfo.guid}`) as HTMLInputElement;
    const unitPriceInput = document.getElementById(`unitPrice_${itemInfo.guid}`) as HTMLInputElement;
    const unitInput = document.getElementById(`dlg_unit_${itemInfo.guid}`) as HTMLInputElement;
    const otherInput = document.getElementById(`construction_${itemInfo.guid}_other`) as HTMLInputElement;

    if (!initData) { // 初期化時でなかったら更新をかける
      // 単価をinputに表示
      unitPriceInput.value = unitPrice.toString();
      unitInput.value = selectedOption.getAttribute('data-unit');

      // 見積金額を計算
      const quantity = parseFloat(quantityInput.value) || 0; // デフォルト値を指定
      const estimatedPrice = Math.floor(unitPrice * quantity);
      estimatedPriceInput.value = estimatedPrice.toString();
    }

    // その他が選択されたならば、入力欄を有効にする
    // 付帯工事がその他の場合、selectを消してinputを表示
    const otherFlag = selectedOption.getAttribute('data-other-flag');
    // displayをotherFlagによって切り替える
    if (!this.view_mode) {
      nameSelect.style.display = otherFlag === '1' ? 'none' : 'inline-block';
      otherInput.style.display = otherFlag === '1' ? 'inline-block' : 'none';
    }
  }

  /**
   * 編集ボタン押下
   */
  protected btnEditEvent = () => {
    const { itemInfo } = this.parentObj;

    this.insertComma(document.getElementById(`unitPrice_${itemInfo.guid}`) as HTMLInputElement);
    this.insertComma(document.getElementById(`estimatedPrice_${itemInfo.guid}`) as HTMLInputElement);

    document.getElementById(`btnChangeItem_${itemInfo.guid}`).style.display = 'block';
    document.getElementById(`btnDeleteItem_${itemInfo.guid}`).style.display = 'block';

    const editModeElements = document.getElementById(`itemListTable_${itemInfo.guid}`).querySelectorAll<HTMLElement>(`.editMode:not(.nameOther):not(#construction_${itemInfo.guid})`);
    editModeElements.forEach((element) => {
      element.style.display = 'inline-block'; // 表示にする
    });
    const viewModeElements = document.getElementById(`itemListTable_${itemInfo.guid}`).querySelectorAll<HTMLElement>('.viewMode');
    viewModeElements.forEach((element) => {
      element.style.display = 'none'; // 非表示にする
    });

    // 3Dにて紐づけアイテムを変更する
    if (document.getElementById(`btnChangeItem_${itemInfo.guid}`)) {
      document.getElementById(`btnChangeItem_${itemInfo.guid}`).addEventListener('click', this.changeItem);
    }
    // 紐づけアイテムを削除する
    if (document.getElementById(`btnDeleteItem_${itemInfo.guid}`)) {
      document.getElementById(`btnDeleteItem_${itemInfo.guid}`).addEventListener('click', this.deleteLinkedItem);
    }
  }

  /** 紐づけアイテムを変更する */
  private changeItem = () => {
    // 紐づけするアイテムがない場合はアラート
    if (!marietta.webcad.WebCADGlobal.quotationItemList.hasDataRows) {
      marietta.webcad.WebCADGlobal.showAlert('間取りを作成してください');
      return;
    }

    const intersectItem = PinDialogUtil.getCurrentItem(this.parentObj.itemInfo?.intersectItem?.uid);
    PinDialogUtil.currentItem(intersectItem);
    const iteminfo = intersectItem instanceof MonicaObject ? intersectItem.itemInfo : intersectItem?.parentObj?.itemInfo;

    const param = {
      isEditMode: true,
      isWizard: (marietta.webcad.WebCADGlobal.currentDialog instanceof marietta.webcad.view.dialog.WizardPinIntersect),
      itemName: PinDialogUtil.getItemName(iteminfo, this.parentObj.itemInfo.intersectItem),
      roomName: PinDialogUtil.getItemRoomName(iteminfo, this.parentObj.itemInfo.intersectItem, this.parentObj.itemInfo),
    };
    const dialog = marietta.webcad.WebCADGlobal.showDialog(marietta.webcad.view.dialog.PinItemChangeDialog, true, true, false, false, param);

    if (marietta.webcad.WebCADGlobal.dimensionMenu.mode === '3D') {
      dialog.callBack = this.changeItemCallBack3D;
    } else {
      dialog.callBack = this.changeItemCallBack2D;
    }
  }

  /** 紐づけアイテムを削除する */
  private deleteLinkedItem = () => {
    marietta.webcad.WebCADGlobal.showConfirmDialog('紐づけアイテムを削除してもよろしいですか？', '確認', () => {
      const { itemInfo } = this.parentObj;
      itemInfo.intersectItem = null;
      itemInfo.is_pin_update_flg = true;
      marietta.webcad.WebCADGlobal.quotationItemList.requestRebuild();
      this.close();
    });
  }

  private changeItemCallBack3D = () => {
    this.saveData();
    this.close();
    new WizardTool().changeMode3D(this.parentObj.itemInfo);
  }

  private changeItemCallBack2D = (isWizard: boolean = false) => {
    marietta.webcad.WebCADGlobal.itemManager.currentItem = null;
    if (this.parentObj) this.parentObj.textHide();
    marietta.webcad.WebCADGlobal.overlapItemList.hideList();

    this.saveData();
    this.close();

    // ピンとアイテムの紐づけ
    const mode3D = new Mode3DTool();
    const option = <optChangeWizardMode>{
      isWizardMode: isWizard,
      isChangeMode: true,
      iteminfo: this.parentObj.itemInfo,
    };
    mode3D.setOption(option);
    mode3D.start();
  }

  /**
   * イメージにイベントを付与する
   * @param width
   * @param linkElem
   */
  private addEventLinkImage(width: number, linkElem: HTMLImageElement) {
    const maxWidth = width - 20; // margin分引く
    const viewHeight = 180; // imgの表示領域 190px(linkWrap) - 10px(textWrap margin)
    const maxHeight = viewHeight - 30; // margin分引く
    linkElem.style.maxWidth = `${maxWidth}px`;
    linkElem.style.maxHeight = `${maxHeight}px`;

    // 画像位置の設定
    linkElem.addEventListener('load', (e: Event) => {
      const imgWidth = (<HTMLImageElement>e.target).width;
      const imgHeight = (<HTMLImageElement>e.target).height;
      const ratio = imgHeight / imgWidth;
      let [top, bottom, left] = [0, 0, 0, 0];
      if (ratio <= 1) { // 正方形、もしくは横長
        const h = imgHeight * (maxWidth / imgWidth);
        top = Math.abs(viewHeight - h) / 2;
        bottom = Math.abs(viewHeight - h) / 2;
        left = 10;
      } else { // 縦長
        top = 20;
        bottom = 10;
        const w = imgWidth * (maxHeight / imgHeight);
        left = Math.abs(width - w) / 2 + 1; // (+ 1は枠分)
      }
      // linkElem.style.margin = `${top}px ${left}px ${bottom}px`;
    });
    // エラーハンドリングの追加
    linkElem.addEventListener('error', (e: Event) => {
      document.getElementById('beforeImg').remove();
      const noImage = document.createElement('img');
      noImage.id = "noImage";
      noImage.src = `${marietta.webcad.WebCADGlobal.webcad2Dmanager.assets_url}/noImage.png`;
      noImage.setAttribute('src', noImage.src);
      document.getElementById(`imgBefore_${this.parentObj.itemInfo.guid}`).appendChild(noImage);

      // 代替画像が読み込まれた際の処理
      noImage.addEventListener('load', (e: Event) => {
        (<HTMLImageElement>e.target).style.maxWidth = `${maxWidth}px`;
        (<HTMLImageElement>e.target).style.maxHeight = `${maxHeight}px`;
      }, { once: true }); // 一度だけ発火
    });
  }

  /**
   * 画像部分の作成
   */
  public createLinkElement(width: number): HTMLElement {
    const { itemInfo } = this.parentObj;
    const btnWrap: HTMLElement = document.createElement('div');
    btnWrap.setAttribute('class', 'btnWrap');

    if (!this.view_mode) {
      const btnBefore: HTMLElement = document.createElement('button');
      btnBefore.setAttribute('id', `btnBefore_${itemInfo.guid}`);
      btnBefore.setAttribute('class', 'before active');
      btnBefore.setAttribute('value', 'before');
      btnBefore.innerHTML = '<span class="jp">Before</span><span class="en">Before</span>';
      btnWrap.appendChild(btnBefore);

      const btnAfter: HTMLElement = document.createElement('button');
      btnAfter.setAttribute('id', `btnAfter_${itemInfo.guid}`);
      btnAfter.setAttribute('class', 'after');
      btnAfter.setAttribute('value', 'after');
      btnAfter.innerHTML = '<span class="jp">After</span><span class="en">After</span>';
      btnWrap.appendChild(btnAfter);
    }

    const arrowWrap: HTMLElement = this.createArrowBtnsView();
    btnWrap.appendChild(arrowWrap);

    const linkElem: HTMLImageElement = document.createElement('img');
    linkElem.setAttribute('class', 'pinImg');
    this.addEventLinkImage(width, linkElem);

    const url = itemInfo.link[0].binary ?? itemInfo.link[0].url;
    linkElem.setAttribute('src', url);

    const atag: HTMLElement = document.createElement('a');
    atag.id = 'beforeImg';
    atag.setAttribute('href', itemInfo.link[0].url);
    atag.setAttribute('target', '_blank');
    atag.appendChild(linkElem);

    // STARTS_LIDAR-1845 紐づけ付帯工事詳細ダイアログの変更
    // 画像の下に備考を配置するため
    const borderWrap: HTMLElement = document.createElement('div');
    borderWrap.setAttribute('class', 'borderWrap');

    const imgWrap: HTMLElement = document.createElement('div');
    imgWrap.setAttribute('class', 'imgWrap');

    const imgBefore: HTMLElement = document.createElement('div');
    imgBefore.setAttribute('id', `imgBefore_${itemInfo.guid}`);
    imgBefore.setAttribute('class', 'imgBefore');
    imgBefore.appendChild(atag);

    const imgAfter: HTMLElement = document.createElement('div');
    imgAfter.setAttribute('id', `imgAfter_${itemInfo.guid}`);
    imgAfter.setAttribute('class', 'imgAfter');
    // シェアモードではAfter画像の差し替え・削除を行わせないため、操作ボタンを生成しない
    const isShareMode: boolean = marietta.webcad.WebCADGlobal.shareModeManager.isShareMode;
    const afterLink = this.afterImage[0];
    if (afterLink?.url  || afterLink?.binary) {
      const elem = this.appendDocument([], true);
      if (elem) {
        imgAfter.appendChild(elem);
        if (!isShareMode) {
          const deleteButton: HTMLElement = document.createElement('span');
          deleteButton.setAttribute('id', `btnDocDelete_${itemInfo.guid}`);
          deleteButton.setAttribute('class', 'icon icon-close btnDocDelete');
          imgAfter.appendChild(deleteButton);
        }
      }
    } else {
      this.createBtnDocElement(imgAfter);
    }
    // 備考
    const remarksTextarea = this.createRemarkView();
    imgWrap.appendChild(imgBefore);
    imgWrap.appendChild(imgAfter);
    borderWrap.appendChild(imgWrap);
    borderWrap.appendChild(remarksTextarea);

    const linkWrap: HTMLElement = document.createElement('div');
    linkWrap.setAttribute('class', 'linkWrap');
    linkWrap.style.display = 'block';
    linkWrap.appendChild(btnWrap);
    linkWrap.appendChild(borderWrap);

    return linkWrap;
  }

  createBtnDocElement(imgAfter: HTMLElement = null) {
    // シェアモードではAfter画像の登録を行わせないため、起動ボタンを生成しない
    if (marietta.webcad.WebCADGlobal.shareModeManager.isShareMode) return;

    // after画像撮影の起動ボタン
    const { itemInfo } = this.parentObj;
    const ua = marietta.webcad.WebCADGlobal.userAgentManager;
    if (document.getElementById(`imgAfter_${itemInfo.guid}`)) {
      imgAfter = document.getElementById(`imgAfter_${itemInfo.guid}`);
    }
    if (ua.isMobile || ua.isTablet) {
      const camera = this.createCameraButton('startup');
      imgAfter.appendChild(camera);
      const cameraRoll = this.createCameraButton('cameraRoll');
      imgAfter.appendChild(cameraRoll);
      const textElement = document.createElement('div');
      textElement.innerHTML = `カメラを起動または<span id="openCameraRool_${itemInfo.guid}">カメラロール</span>、<br><span id="openDoc_${itemInfo.guid}">企画ドキュメント</span>から選択`;
      imgAfter.appendChild(textElement);
    } else {
      // 参照ボタン
      const referButtonElement = document.createElement('div');
      referButtonElement.setAttribute('class', 'btnWrap');
      const referButton: HTMLElement = document.createElement('button');
      referButton.setAttribute('id', `btnGetDoc_${itemInfo.guid}`);
      referButton.addEventListener('click', this.btnGetDocHandler);
      referButtonElement.appendChild(referButton);
      imgAfter.appendChild(referButtonElement);
    }
  }

  /**
   *
   * @param e
   */
  onBtnBeforeEvent = (e: Event) => {
    const { itemInfo } = this.parentObj;
    const imgBefore = document.getElementById(`imgBefore_${itemInfo.guid}`) as HTMLElement;
    const imgAfter = document.getElementById(`imgAfter_${itemInfo.guid}`) as HTMLElement;
    const btnBefore = document.getElementById(`btnBefore_${itemInfo.guid}`) as HTMLElement;
    const btnAfter = document.getElementById(`btnAfter_${itemInfo.guid}`) as HTMLElement;
    imgBefore.style.display = 'block'; // imgBefore を表示
    imgAfter.style.display = 'none'; // imgAfter を非表示
    btnBefore.classList.add('active');
    btnAfter.classList.remove('active');
    // 備考・写真以外の操作を有効に変更
    this.setDisabled(false);
  }

  /**
   *
   * @param e
   */
  onBtnAfterEvent = (e: Event) => {
    const { itemInfo } = this.parentObj;
    const imgBefore = document.getElementById(`imgBefore_${itemInfo.guid}`) as HTMLElement;
    const imgAfter = document.getElementById(`imgAfter_${itemInfo.guid}`) as HTMLElement;
    const btnBefore = document.getElementById(`btnBefore_${itemInfo.guid}`) as HTMLElement;
    const btnAfter = document.getElementById(`btnAfter_${itemInfo.guid}`) as HTMLElement;
    imgBefore.style.display = 'none'; // imgBefore を非表示
    imgAfter.style.display = 'block'; // imgAfter を表示
    btnAfter.classList.add('active');
    btnBefore.classList.remove('active');
    // 備考・写真以外の操作を無効に
    this.setDisabled(true);
  }

  /**
   * 備考・写真以外の操作の有効・無効を操作
   * @param isDisabled true: 操作不可に変更
   */
  private setDisabled(isDisabled: boolean): void {
    // シェアモードでは操作不可を維持する（Before/Afterの切り替えで有効に戻さない）
    if (!isDisabled && marietta.webcad.WebCADGlobal.shareModeManager.isShareMode) return;

    const disabledClassName = "disabledInput";
    const { itemInfo } = this.parentObj;
  
    // 操作対象IDリスト
    const ids = [
      "masterDefault", "masterCompany",
      `checkInclude_${itemInfo.guid}`,
      `btnChangeItem_${itemInfo.guid}`,
      `btnDeleteItem_${itemInfo.guid}`,
      "nameSearch", "nameSearchClearBtn",
      `mediumItem_${itemInfo.guid}`,
      `subitem_${itemInfo.guid}`,
      `quantity_${itemInfo.guid}`,
      `dlg_unit_${itemInfo.guid}`,
      `unitPrice_${itemInfo.guid}`,
      `estimatedPrice_${itemInfo.guid}`,
      `burden_${itemInfo.guid}`,
      `dialog_reason_${itemInfo.guid}`,
      `construction_${itemInfo.guid}`
    ];
  
    ids.forEach(id => {
      const elm = document.getElementById(id) as HTMLInputElement;
      if (!elm) return;
    
      const label = document.querySelector(`label[for="${id}"]`) as HTMLLabelElement;
    
      if (!isDisabled) {
        // 有効化するときは、前回無効だったものは無効のまま
        const wasDisabled = this.previousDisabledState[id] ?? false;
        elm.disabled = wasDisabled;
        if (wasDisabled) {
          elm.classList.add(disabledClassName);
          label?.classList.add(disabledClassName);
        } else {
          elm.classList.remove(disabledClassName);
          label?.classList.remove(disabledClassName);
        }
      } else {
        // 無効化するときは全て無効化
        this.previousDisabledState[id] = elm.disabled; // 現在の状態を保存
        if(elm.disabled) return; // すでに操作不可の場合は何もしない
        elm.disabled = true;
        elm.classList.add(disabledClassName);
        label?.classList.add(disabledClassName);
      }
    });
  }

  /**
   * カメラ起動ボタン作成
   * @param captureType カメラ起動かカメラロールか
   * @returns
   */
  private createCameraButton(captureType: 'startup' | 'cameraRoll'): HTMLElement {
    const { itemInfo } = this.parentObj;
    this.afterBtnBaseId = 'afterBtn';
    const id = captureType === 'startup' ? this.afterBtnBaseId : 'cameraRoll';
    // after画像撮影の起動ボタン
    const afterContainer = document.createElement('div');
    // btnタグ
    if (captureType === 'startup') {
      const afterBtn: HTMLElement = document.createElement('button');
      afterBtn.setAttribute('id', `${id}_${itemInfo.guid}`);
      afterContainer.appendChild(afterBtn);
    }
    // inputタグ
    const afterInput = document.createElement('input');
    afterInput.setAttribute('type', 'file');
    afterInput.setAttribute('id', `${id}_input_${itemInfo.guid}`);
    if (captureType === 'startup') afterInput.setAttribute('capture', 'environment');
    afterInput.setAttribute('accept', 'image/*');
    afterInput.style.display = 'none';
    afterContainer.appendChild(afterInput);
    return afterContainer;
  }

  /**
   * カメラ起動イベント
   */
  private cameraStartEvent = () => {
    const { itemInfo } = this.parentObj;
    // カメラ起動
    const camera = document.getElementById(`${this.afterBtnBaseId}_input_${itemInfo.guid}`);
    if (camera) {
      camera.click();
      // 撮影した画像読み込み
      camera.addEventListener('change', this.photographEvent);
    }
  }

  /**
   * カメラロール起動イベント
   */
  private cameraRollStartEvent = () => {
    const { itemInfo } = this.parentObj;
    const cameraRoll = document.getElementById(`cameraRoll_input_${itemInfo.guid}`);
    if (cameraRoll) {
      cameraRoll.click();
      // カメラロールの画像読み込み
      cameraRoll.addEventListener('change', this.photographEvent);
    }
  }

  /**
   * 撮影した画像を取得
   */
  private photographEvent = async (e: TouchEvent | MouseEvent) => {
    /** 画像読み込み */
    const readFileAsDataURL = (file: File): Promise<string> => new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => resolve(reader.result as string);
      reader.onerror = reject;
      reader.readAsDataURL(file);
    });
    try {
      const file = (<HTMLInputElement>e.target).files?.[0];
      if (!file) {
        console.error('No file selected');
        return;
      }
      const image = await readFileAsDataURL(file);
      this.afterImage[this.currentNumber - 1].binary = image;
      this.createAfterImageElement();
    } catch (err) {
      console.error(err);
    }
  }

  /**
   * ドキュメント データ イベント ハンドラを取得する
   * @return void
   * @param e => mouse event
   */
  protected btnGetDocHandler = (e: any) => {
    // e.preventDefault();
    // 1枚の画像は1つのピンにしか紐づけられないため、使用済みの画像と画像以外のドキュメントは選択させない
    const { itemInfo } = this.parentObj;
    const usedLinks = [
      ...marietta.webcad.WebCADGlobal.webcad2Dmanager.getUsedImageLinks(itemInfo),
      ...(itemInfo.link ?? []),
      ...this.afterImage,
    ];
    marietta.webcad.manager.APIManager.selectPlanningDocument(this.appendDocument, { excludeLinks: usedLinks, imageOnly: true });
  }

  /**
   * 見積参入がクリックされた
   * @param e
   */
  protected onChangeIncludeCheck = (e: any) => {
    const { itemInfo } = this.parentObj;
    const checkInclude: boolean = (document.getElementById(`checkInclude_${itemInfo.guid}`) as HTMLInputElement).checked;
    if (this.parentObj.itemInfo?.auxiliaryData?.auxiliaryDatum) {
      this.parentObj.itemInfo.auxiliaryData.auxiliaryDatum.estimatedEntryFlg = Number(checkInclude);
    }
  }

  /**
   * 付帯工事名から検索：クリアボタン制御
   * @param e
   */

  /* フォーカスON */
  private focusNameSearch = (e: any) => {
    const nameSearchElement = document.getElementById('nameSearch') as HTMLInputElement;
    if( 0 < nameSearchElement.value.length ){
      document.getElementById('nameSearchClearBtn').classList.add('active');
      document.getElementById('nameSearchListBox').classList.add('active');
    }
  };

  /* フォーカスOFF */
  private blurNameSearch = (e: any) => {

    console.log(document.activeElement);

    // フォーカスがクリアボタンに移動したかどうかを判別;
    setTimeout(() => {
      const focusedElement = document.activeElement;
      if (
        document.activeElement !== document.getElementById('nameSearchClearBtn')) {
        document.getElementById('nameSearchClearBtn').classList.remove('active');
        document.getElementById('nameSearchListBox').classList.remove('active');
      } else {
        document.getElementById('nameSearch').focus(); // フォーカスを元に戻す
      }
    }, 100); // 適切な遅延時間を設定
  };

  /* 検索内容のクリア */
  private nameSearchClear = (e: any) => {
    e.preventDefault(); // フォーカスを防止
    const nameSearchElement = document.getElementById('nameSearch') as HTMLInputElement;
    nameSearchElement.value = ''; // 入力内容を空にする
    nameSearchElement.focus(); // フォーカスを再設定

    document.getElementById('nameSearchClearBtn').classList.remove('active');
    document.getElementById('nameSearchListBox').classList.remove('active');

    //リストの中を初期化
    const ulElement = document.getElementById('nameSearchList') as HTMLUListElement;
    ulElement.innerHTML = '';
  };

  private _nameSearchResult:nameSearchResult[];
  /**
   * 付帯工事名から検索：ヒットした付帯工事名の表示
   * @param e
   */
  private onChangeNameSearch = (e: any) => {
    document.getElementById('nameSearchListBox').classList.add('active');
    const nameSearchValue = (document.getElementById('nameSearch') as HTMLInputElement).value;

    let searchResult:nameSearchResult[] = [];
    let auxList:auxiliaryConstructions[];
    let subCategory:auxiliarySubCategory;
    let subCategories:auxiliarySubCategory[];
    let midCategory:auxiliaryMiddleCategory;
    let midCategories:auxiliaryMiddleCategory[];
    if (this.selectedMaster === MasterType.Company && marietta.webcad.WebCADGlobal.AUXILIARY_MASTER?.company) {
      midCategories = marietta.webcad.WebCADGlobal.AUXILIARY_MASTER.company;
    }else {
      midCategories = marietta.webcad.WebCADGlobal.AUXILIARY_MASTER.default;
    }

    if( !midCategories ) return

    midCategories.forEach( (data) => {
      midCategory = data;
      subCategories = data.sub_categories;
      data.sub_categories.forEach( (sub_data) => {
        subCategory = sub_data;
        auxList = sub_data.auxiliary_constructions;
        sub_data.auxiliary_constructions.forEach( (aux_data) => {
          if( -1 < aux_data.name.indexOf(nameSearchValue) ){
            searchResult.push(
              {
                auxiliaryConstruction:aux_data,
                auxiliaryConstructionList:auxList,
                subCategory:subCategory,
                subCategoryList:subCategories,
                middleCategory:midCategory,
                middleCategoryList:midCategories
              }
            )
          }
        });
      });
    });

    //保持
    this._nameSearchResult = searchResult;

    /* 入力された値で付帯工事名を検索 */
    const nameSearchResultList = [];
    searchResult.forEach( (data) => {
      nameSearchResultList.push( { title:data.auxiliaryConstruction.name, id:data.auxiliaryConstruction.id } );
    } )

    /* 取得したリストをulの#nameSearchListに挿入 */
    const ulElement = document.getElementById('nameSearchList') as HTMLUListElement;
    ulElement.innerHTML = '';

    if (ulElement) {
      // 配列をループして <li> 要素を作成し、ul に追加
      nameSearchResultList.forEach((item: {title:string, id:string}) => {
        const liElement = document.createElement('li');
        liElement.textContent = item.title; // リスト項目の内容を設定
        liElement.setAttribute("data-id", item.id );
        ulElement.appendChild(liElement); // <ul> に <li> を追加
      });
    }

  };

  /**
   * 付帯工事名から検索：付帯工事名を選択
   * @param e
   */
  private onSetName = (e: any) => {

    console.log("onSetNameonSetNameonSetName")
    e.preventDefault(); // フォーカスを防止
    const searchBox = document.getElementById('nameSearch') as HTMLInputElement;
    if (searchBox) {
      searchBox.focus(); // フォーカスを維持
    }

    const { itemInfo } = this.parentObj;
    const clickedLi = e.target as HTMLLIElement;
    console.log('クリックされたli:', clickedLi.textContent);

    //データを探す
    const id:string = clickedLi.getAttribute("data-id");
    /* 選択した付帯工事名から中項目、細項目を逆引き */
    let mediumItemTargetValue;
    let subitemTargetValue;
    let nameTargetValue;
    this._nameSearchResult.forEach( (data) => {
      if( data.auxiliaryConstruction.id == id ){
        this.middleCategoryList = data.middleCategoryList;
        this.createMediumList();
        this.subCategoryList = data.subCategoryList;
        mediumItemTargetValue = data.middleCategory.middle_category_name;
        this.createSubCategoryList(mediumItemTargetValue);
        subitemTargetValue = data.subCategory.sub_category_name;
        this.createConstructionList(subitemTargetValue, true);
        nameTargetValue = data.auxiliaryConstruction.name;
      }
    });

    /* 検索一覧から選択された付帯工事名をもとに中項目をセット */
    const mediumItemSelect = document.getElementById(`mediumItem_${itemInfo.guid}`) as HTMLSelectElement;
    if (mediumItemSelect) {
      const { options } = mediumItemSelect;
      for (let i = 0; i < options.length; i++) {
        if (options[i].value === mediumItemTargetValue) {
          options[i].selected = true;
          break;
        }
      }
    }

    /* 検索一覧から選択された付帯工事名をもとに細項目をセット */
    const subitemSelect = document.getElementById(`subitem_${itemInfo.guid}`) as HTMLSelectElement;
    if (subitemSelect) {
      const { options } = subitemSelect;
      for (let i = 0; i < options.length; i++) {
        if (options[i].value === subitemTargetValue) {
          options[i].selected = true;
          break;
        }
      }
    }

    /* 検索一覧から選択された付帯工事名をもとに細項目をセット */
    const nameSelect = document.getElementById(`construction_${itemInfo.guid}`) as HTMLSelectElement;
    if (subitemSelect) {
      const { options } = nameSelect;
      for (let i = 0; i < options.length; i++) {
        if (options[i].value === nameTargetValue) {
          options[i].selected = true;
          break;
        }
      }
    }
    // 検索結果の選択は change が発火しないため、単価・単位・見積金額を明示的に再計算する
    this.onConstructionSelected(false);

    //絞り込みテキスト
    (document.getElementById('nameSearch') as HTMLInputElement).value = clickedLi.textContent;
    document.getElementById('nameSearchListBox').classList.remove('active');
  };

  public appendDocument = (docList = [], isLoad: boolean = false): (void | HTMLElement) => {
    const { itemInfo } = this.parentObj;
    let hasImage = true;
    const setAfterImage = (index: number, name: string, url: string, id?: string, binary?: string) => {
      if(!this.afterImage[index]) return;
      this.afterImage[index].name = name;
      this.afterImage[index].url = url;
      this.afterImage[index].id = id;
      this.afterImage[index].binary = binary;
    }
    if (docList.length > 0) {
      docList.forEach((doc, i) => {
        const linkData = itemInfo.link[this.currentNumber - 1];
        const afterLinkData = itemInfo.after_link?.find(link => link.id === linkData.id);
        // afterLinkがある場合は更新・ない場合は追加する
        if(afterLinkData) {
          afterLinkData.name = doc.file_name;
          afterLinkData.url = doc.file_path
        } else {
          itemInfo.after_link.push({id:linkData.id, name: doc.file_name, url: doc.file_path});
        }
        setAfterImage(this.currentNumber - 1, doc.file_name, doc.file_path, linkData.id);
      });
    } else if (itemInfo.after_link?.length) {
      itemInfo.after_link.forEach((link,i) => {
        setAfterImage(i, link.name, link.url, link.id, link.binary);
      })
    } else {
      // after画像がない
      hasImage = false;
    }
    if (hasImage) {
      const imgElem = this.createAfterImageElement(isLoad);
      if (isLoad) {
        return imgElem;
      }
    }
  }

  public createAfterImageElement = (isLoad: boolean = false): (void | HTMLElement) => {
    const width = this.parentObj.getWidth();
    const { itemInfo } = this.parentObj;
    const linkElem: HTMLElement = document.createElement('img');
    linkElem.setAttribute('class', 'pinImg');
    const maxWidth = width - 20; // margin分引く
    const viewHeight = 180; // imgの表示領域 190px(linkWrap) - 10px(textWrap margin)
    const maxHeight = viewHeight - 30; // margin分引く
    linkElem.style.maxWidth = `${maxWidth}px`;
    linkElem.style.maxHeight = `${maxHeight}px`;
    const afterImage = this.afterImage[this.currentNumber - 1];
    if (afterImage?.binary) {
      linkElem.setAttribute('src', afterImage.binary);
    } else if (afterImage?.url) {
      linkElem.setAttribute('src', afterImage.url);
    } else {
      console.warn('表示する画像がありません');
    }

    const atag: HTMLElement = document.createElement('a');
    if (afterImage?.url) {
      atag.setAttribute('href', afterImage.url);
    }
    atag.id = "afterImg";
    atag.setAttribute('target', '_blank');
    atag.appendChild(linkElem);
    if (isLoad) {
      return atag;
    }
    const imgAfter = document.getElementById(`imgAfter_${itemInfo.guid}`) as HTMLElement;
    imgAfter.innerHTML = '';
    imgAfter.appendChild(atag);
    const deleteButton = this.createDeleteDocumentBtn(itemInfo.guid);
    imgAfter.appendChild(deleteButton);
  }

  /**
   * 画像削除ボタンを作成
   */
  private createDeleteDocumentBtn(guid: string) {
    const deleteButton: HTMLElement = document.createElement('span');
    deleteButton.setAttribute('id', `btnDocDelete_${guid}`);
    deleteButton.setAttribute('class', 'icon icon-close btnDocDelete');
    deleteButton.addEventListener('mousedown', this.deleteDocument);
    return deleteButton;
  }

  public deleteDocument = (): void => {
    const { itemInfo } = this.parentObj;
    const afterImg = this.afterImage[this.currentNumber - 1]
    if(!afterImg) return;
    if (afterImg.binary) afterImg.binary = '';
    if (afterImg.url) afterImg.url = '';
    if (afterImg.name) afterImg.name = '';
    if (afterImg.id) afterImg.id = null;
    const imgAfter = document.getElementById(`imgAfter_${itemInfo.guid}`) as HTMLElement;
    imgAfter.innerHTML = '';
    this.createBtnDocElement();
    this.setAfterImageEvent();
  }

  /**
   * Cancelボタンがクリックされた
   * @return void
   * @param e => mouse event
   */
  btnCancelHandler = () => {
    this.close();
  }

  /**
   * OKボタンがクリックされた
   */
  private btnCompleteHandler = () => {
    // バリデーションチェック
    const checkInclude: boolean = (document.getElementById(`checkInclude_${this.parentObj.itemInfo.guid}`) as HTMLInputElement).checked;
    if (checkInclude && this.inputValidationCheck()) { // 見積参入ON
      marietta.webcad.WebCADGlobal.showAlert('付帯工事名が入力されていません。');
      return;
    }
    document.getElementById(`btnChangeItem_${this.parentObj.itemInfo.guid}`).style.display = 'none';
    document.getElementById(`btnDeleteItem_${this.parentObj.itemInfo.guid}`).style.display = 'none';
    this.saveData();

    this.close();
  }

  public closeEvent(): void {
    super.closeEvent();
    ThreeView.get().unSelectedObject();
  }

  /**
   * 入力項目のバリデーションチェック
   * ピン登録API必須項目
   *  - 付帯工事ID
   *  - 見積もり数量 入力時に空白にならないように制限がかかっている
   *  - 見積もり単価 入力時に空白にならないように制限がかかっている
   *  - 見積もり金額 入力時に空白にならないように制限がかかっている
   *  - その他フラグ
   */
  private inputValidationCheck(): boolean {
    const { itemInfo } = this.parentObj;
    const nameSelect = document.getElementById(`construction_${itemInfo.guid}`) as HTMLSelectElement; // 付帯工事名
    const selectedOption = nameSelect.options[nameSelect.selectedIndex];
    // その他の時
    if (selectedOption.getAttribute('data-other-flag') === '1') {
      const otherInput = document.getElementById(`construction_${itemInfo.guid}_other`) as HTMLInputElement;
      // 付帯工事名が空
      return (otherInput.value === '')
    }
    // 付帯工事名が空
    return (nameSelect.value === '');
  }

  protected saveData() {
    const { itemInfo } = this.parentObj;
    // 中項目
    const mediumItemSelect = document.getElementById(`mediumItem_${itemInfo.guid}`) as HTMLSelectElement;
    const mediumItemView = document.getElementById(`mediumItemBox_${itemInfo.guid}`);
    mediumItemView.textContent = mediumItemSelect.options.length > 0 && mediumItemSelect.selectedIndex !== -1 ? mediumItemSelect.options[mediumItemSelect.selectedIndex].text : '';

    // 細項目
    const subitemSelect = document.getElementById(`subitem_${itemInfo.guid}`) as HTMLSelectElement;
    const subitemView = document.getElementById(`subitemBox_${itemInfo.guid}`);
    subitemView.textContent = subitemSelect.options.length > 0 && subitemSelect.selectedIndex !== -1 ? subitemSelect.options[subitemSelect.selectedIndex].text : '';

    // 付帯工事名
    const nameSelect = document.getElementById(`construction_${itemInfo.guid}`) as HTMLSelectElement;
    const nameView = document.getElementById(`constructionBox_${itemInfo.guid}`);
    const nameOther = document.getElementById(`construction_${itemInfo.guid}_other`) as HTMLInputElement;
    const otherFlag = nameSelect.selectedIndex !== -1 ? parseInt(nameSelect.options[nameSelect.selectedIndex].getAttribute('data-other-flag'), 10) : NaN;
    // その他の時の入力値
    const customInputValue = nameOther?.value;
    // その他じゃないときの値
    const selectedOptionText = nameSelect.options.length > 0 && nameSelect.selectedIndex != -1 ? nameSelect.options[nameSelect.selectedIndex].text : '';
    nameView.textContent = otherFlag === 1 ? customInputValue : selectedOptionText;

    // 数量
    const quantityInput = document.getElementById(`quantity_${itemInfo.guid}`) as HTMLInputElement;
    const quantityView = document.getElementById(`quantityBox_${itemInfo.guid}`);
    quantityView.textContent = quantityInput.value;

    // 単位
    const unitInput = document.getElementById(`dlg_unit_${itemInfo.guid}`) as HTMLInputElement;
    const unitView = document.getElementById(`unitBox_${itemInfo.guid}`);
    unitView.textContent = unitInput.value;

    // 単価
    const unitPriceInput = document.getElementById(`unitPrice_${itemInfo.guid}`) as HTMLInputElement;
    const unitPriceView = document.getElementById(`unitPriceBox_${itemInfo.guid}`);
    unitPriceView.textContent = unitPriceInput.value;

    // 見積金額
    const estimatedPriceInput = document.getElementById(`estimatedPrice_${itemInfo.guid}`) as HTMLInputElement;
    const estimatedPriceView = document.getElementById(`estimatedPriceBox_${itemInfo.guid}`);
    estimatedPriceView.textContent = estimatedPriceInput.value;

    // 入居者負担割合
    const burdenInput = document.getElementById(`burden_${itemInfo.guid}`) as HTMLInputElement;
    const burdenView = document.getElementById(`burdenBox_${itemInfo.guid}`);
    burdenView.textContent = burdenInput.value;

    // 修繕理由
    const reasonSelect = document.getElementById(`dialog_reason_${itemInfo.guid}`) as HTMLSelectElement;
    const reasonView = document.getElementById(`reasonBox_${itemInfo.guid}`);
    reasonView.textContent = reasonSelect.options.length > 0 && reasonSelect.selectedIndex !== -1 ? reasonSelect.options[reasonSelect.selectedIndex].text : '';

    // 備考
    const remarksTextarea = document.getElementById(`dialog_remarks_${itemInfo.guid}`) as HTMLTextAreaElement;
    const id = this.parentObj.itemInfo.link[this.currentNumber - 1].id;
    if(id) {
      const remark = this.parentObj.itemInfo.remarks.find(remark => remark.id === id);
      if(remark) {
        remark.text = remarksTextarea.value;
      } else {
        // ない場合は作成して追加
        const newRemark: RemarksType = {id: id, text: remarksTextarea.value};
        this.parentObj.itemInfo.remarks.push(newRemark);
      }
    }

    const editModeElements = document.getElementById(`itemListTable_${itemInfo.guid}`).querySelectorAll<HTMLElement>('.editMode');
    editModeElements.forEach((element) => {
      // eslint-disable-next-line no-param-reassign
      element.style.display = 'none'; // 非表示にする
    });
    const viewModeElements = document.getElementById(`itemListTable_${itemInfo.guid}`).querySelectorAll<HTMLElement>('.viewMode');
    viewModeElements.forEach((element) => {
      // eslint-disable-next-line no-param-reassign
      element.style.display = 'inline-block'; // 表示にする
    });

    const room_name = PinDialogUtil.getItemRoomName(this.parentObj.itemInfo, this.parentObj.itemInfo.intersectItem, this.parentObj.itemInfo);

    const checkInclude: boolean = (document.getElementById(`checkInclude_${itemInfo.guid}`) as HTMLInputElement).checked;
    const auxiliaryDatum: AuxiliaryDataInterface = {
      masterType: this.selectedMaster,
      estimatedEntryFlg: Number(checkInclude),
      middleCategory: mediumItemSelect.options[mediumItemSelect.selectedIndex]?.text ?? '',
      subCategory: subitemSelect.options[subitemSelect.selectedIndex]?.text ?? '',
      construction: nameSelect.options[nameSelect.selectedIndex]?.text ?? '',
      constructionId: nameSelect.options[nameSelect.selectedIndex]?.getAttribute('data-id') ?? null,
      quantity: parseFloat(quantityInput.value),
      rate: Math.round(parseFloat(burdenInput.value)) / 100,
      remarks: remarksTextarea.value,
      repair: reasonSelect.options[reasonSelect.selectedIndex]?.text ?? '',
      repairId: reasonSelect.options[reasonSelect.selectedIndex]?.id ?? '',
      totalPrice: parseInt(estimatedPriceInput.value.replace(/,/g, ''), 10),
      unit: unitInput.value,
      unitPrice: parseInt(unitPriceInput.value.replace(/,/g, ''), 10),
      other_flag: otherFlag,
      otherText: otherFlag === 1 ? nameOther.value : '',
      room_name:room_name,
    };

    //付帯工事が見積参入の時は、親もＯＮにする（自動チェック無効化）
    // if( checkInclude ){
    //   marietta.webcad.WebCADGlobal.quotationItemList.setIsQuoteInData( this.parentObj.itemInfo?.intersectItem?.uid, true )
    // }

    // 設定された付帯工事情報が保存されたデータと異なれば、ピン更新APIフラグを立てる
    if (this.saveValidationCheck(auxiliaryDatum)) {
      itemInfo.is_pin_update_flg = true;
    }

    // アイテムに情報を書き戻す
    itemInfo.after_link = [];
    itemInfo.is_register_img = false;
    this.afterImage.forEach((image,i) => {
      itemInfo.after_link.push({ name: image.name, url: image.url, id: image.id , binary: image.binary});
      itemInfo.is_register_img = true;
    })

    itemInfo.auxiliaryData = {} as AuxiliaryData;
    itemInfo.auxiliaryData.auxiliaryDatum = auxiliaryDatum;

    // if (itemInfo.auxiliaryData.auxiliaryDatum.estimatedEntryFlg) {
    //   marietta.webcad.WebCADGlobal.quotationItemList.createData(true);
    // }
    marietta.webcad.WebCADGlobal.quotationItemList.requestRebuild();
  }

  /** 保存されたデータと異なるデータがあれば、ピン更新APIフラグを立てる */
  private saveValidationCheck(saveAuxiliaryDatum: AuxiliaryDataInterface): boolean {
    const auxiliaryDatum = this.parentObj?.itemInfo?.auxiliaryData?.auxiliaryDatum;
    if (!auxiliaryDatum) return true;

    const hasDifferences = (a: Record<string, any>, b: Record<string, any>): boolean => {
      const keys = new Set([...Object.keys(a), ...Object.keys(b)]);

      for (const key of keys) {
        if (a[key] !== b[key]) {
          return true;
        }
      }
      return false;
    };

    return hasDifferences(saveAuxiliaryDatum, auxiliaryDatum);
  }
}
